import { primary2 } from "@shane-collective/design-system";
import { Text, styled } from "tamagui";

export const Label = styled(Text, {
  fontFamily: "$rethinkSans",
  fontWeight: "$semisemibold",
  fontSize: "$sm",
  textAlign: "center",
  color: primary2,
});

export const Title = styled(Text, {
  fontFamily: "$rethinkSans",
  fontWeight: "$semibold",
  fontSize: "$md",
  textAlign: "center",
  color: primary2,
});

